import React from 'react'
import LinePriceTagAltIcon from 'LuxKit/Icons/line/LinePricetagAltIcon'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

export const STANDARD_INCLUSION_TYPE = {
  FREE_TEXT: 'FREE_TEXT',
  ONBOARD_CREDIT: 'ONBOARD_CREDIT',
} as const

export type InclusionType = typeof STANDARD_INCLUSION_TYPE[keyof typeof STANDARD_INCLUSION_TYPE]

function sortByInclusionPriority(a: App.PackageInclusion, b: App.PackageInclusion): number {
  if (a.isHighlighted && !b.isHighlighted) return -1
  if (!a.isHighlighted && b.isHighlighted) return 1
  if (a.parentCategory === STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT && b.parentCategory !== STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT) return -1
  if (a.parentCategory !== STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT && b.parentCategory === STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT) return 1
  return 0
}

export { sortByInclusionPriority }

interface Props {
  standardInclusions: Array<App.PackageInclusion>
  type?: InclusionType
  allInclusions?: boolean
}

function CruiseStandardInclusionList({ standardInclusions, type, allInclusions = false }: Props) {
  const inclusions = [...standardInclusions
    .filter(({ parentCategory }) =>
      allInclusions || (type != null && parentCategory === type),
    )]
    .sort(sortByInclusionPriority)

  return <>
    {!!inclusions.length && inclusions.map((inclusion) => {
      const Icon = inclusion.parentCategory === STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT ? LineUsdCircleIcon : LinePriceTagAltIcon
      return (
        <BodyTextBlock
          key={inclusion.id}
          startIcon={<Icon colour="highlight-secondary" />}
          weight="bold"
          variant="medium"
          colour="highlight-secondary"
        >
          {inclusion.description}
        </BodyTextBlock>
      )
    })}
  </>
}

export default CruiseStandardInclusionList
